import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PACKAGES_BASE_QUERY_KEY } from '@/api/packages/get-packages-dashboard'
import { resetQueries } from '@/utils/api'

interface DeletePackageRequest {
  id: number
}

export const deletePackage = async (data: DeletePackageRequest): Promise<void> => {
  await authAPI.delete(`/packages/${data.id}/permanent`)
}

export const useDeletePackage = () => {
  return useMutation({
    mutationFn: deletePackage,
    onSuccess: () => {
      resetQueries([PACKAGES_BASE_QUERY_KEY])
    },
  })
}
